"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SalesforceForms;
exports.updateLabelPositions = updateLabelPositions;
// Function to check field values and update label positions
function updateLabelPositions(form) {
    if (form === void 0) { form = null; }
    var targetForm = form || document.querySelector('.cms form');
    if (!targetForm) {
        return;
    }
    targetForm.querySelectorAll('input, textarea, select').forEach(function (input) {
        var _a, _b;
        var htmlInput = input;
        var parentElement = input.parentNode;
        if (htmlInput.value || htmlInput === document.activeElement) {
            parentElement.classList.add('active');
            (_a = input.closest('.gfield')) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        }
        else {
            parentElement.classList.remove('active');
            (_b = input.closest('.gfield')) === null || _b === void 0 ? void 0 : _b.classList.remove('active');
        }
    });
}
// Function to set up automatic detection of form step changes
function setupStepChangeDetection(form) {
    // 1. Listen for Gravity Forms specific events
    document.addEventListener('gform_page_loaded', function () {
        setTimeout(function () { return updateLabelPositions(form); }, 100);
    });
    // 2. Listen for common multistep form navigation events
    var navigationButtons = form.querySelectorAll('.gform_next_button, .gform_previous_button, [class*="step"], [class*="nav"], button[type="button"]');
    navigationButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            setTimeout(function () { return updateLabelPositions(form); }, 200);
        });
    });
    // 3. Use MutationObserver to detect when form content changes (step visibility)
    var observer = new MutationObserver(function (mutations) {
        var shouldUpdate = false;
        mutations.forEach(function (mutation) {
            // Check if any form steps became visible/hidden
            if (mutation.type === 'attributes'
                && (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
                var target = mutation.target;
                if (target.closest('.gform_page, .gf_page, .step, [class*="step"]')) {
                    shouldUpdate = true;
                }
            }
            // Check if new form fields were added/removed
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) { // Element node
                        var element = node;
                        if (element.querySelector('input, textarea, select')
                            || element.matches('input, textarea, select')) {
                            shouldUpdate = true;
                        }
                    }
                });
            }
        });
        if (shouldUpdate) {
            setTimeout(function () { return updateLabelPositions(form); }, 100);
        }
    });
    // Start observing the form for changes
    observer.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
    });
    // 4. Listen for hash changes (if steps use URL fragments)
    window.addEventListener('hashchange', function () {
        setTimeout(function () { return updateLabelPositions(form); }, 100);
    });
    // 5. Listen for custom events that might be fired by other multistep plugins
    var customEvents = ['step:changed', 'form:step:changed', 'multistep:changed'];
    customEvents.forEach(function (eventName) {
        document.addEventListener(eventName, function () {
            setTimeout(function () { return updateLabelPositions(form); }, 100);
        });
    });
}
function SalesforceForms() {
    var form = document.querySelector('.cms form');
    if (!form) {
        return;
    }
    // Iterate through each input field and move the
    // label above the field if the input is focused or has a value.
    form.querySelectorAll('input, textarea, select').forEach(function (input) {
        var htmlInput = input;
        var parentElement = input.parentNode;
        // Add input type as a class to the parent element.
        parentElement.classList.add("form-".concat(htmlInput.type));
        input.addEventListener('focus', function () {
            parentElement.classList.add('active');
            // Find the nearest parent node with the class 'gfield'.
            input.closest('.gfield').classList.add('active');
        });
        input.addEventListener('blur', function () {
            if (!htmlInput.value) {
                parentElement.classList.remove('active');
                // Find the nearest parent node with the class 'gfield'.
                input.closest('.gfield').classList.remove('active');
            }
        });
    });
    // Initial check for field values
    updateLabelPositions(form);
    // Make the function globally available for multistep forms
    window.updateFormLabels = updateLabelPositions;
    // Set up automatic detection for form step changes
    setupStepChangeDetection(form);
    form.querySelectorAll('p').forEach(function (p) {
        // Check if the paragraph contains a label and input field.
        var label = p.querySelector('label');
        var input = p.querySelector('input, textarea, select');
        if (!label && input) {
            // Get the text content of the paragraph.
            var text = p.textContent;
            // If the paragraph does not contain a label, add it.
            label = document.createElement('label');
            // Add the text content to the label.
            label.textContent = text;
            // Insert the label before the input field.
            p.insertBefore(label, input);
            // Remove the text content from the paragraph.
            while (p.firstChild && p.firstChild !== label && p.firstChild !== input) {
                p.removeChild(p.firstChild);
            }
            // Add the label to the paragraph.
            p.appendChild(label);
            // Add the input field to the paragraph.
            p.appendChild(input);
        }
    });
}
